import { MM_PHOTO, MM_LOGO, MM_VIDEO, VV_BG, MM_BG } from "../../lib/site";
import { MM_QUOTE, VV_QUOTE } from "../../sections/Testimonial";

export const CASE_ORDER = ["mountain-men", "verjong-vastgoed"];

export const CASES = {
  "mountain-men": {
    client: "Mountain Men",
    url: null,
    logo: { src: MM_LOGO, alt: "Mountain Men logo", framed: true },
    heroPhoto: { src: MM_PHOTO, alt: "Het team van Mountain Men in de bergen", zoom: true },
    cardPhoto: { src: MM_PHOTO, alt: "Het team van Mountain Men", position: "center 62%" },
    photos: [{ src: MM_PHOTO, alt: "Het team van Mountain Men in de bergen" }],
    video: MM_VIDEO,
    bg: MM_BG,
    quote: MM_QUOTE,
    nl: {
      sector: "Outdoor reiscommunity",
      tagline: "Van social media tot complete marketing: wij namen het over, zodat Mountain Men zich volledig kon richten op het bouwen van hun community.",
      intro: "Mountain Men is een snelgroeiende community rond avontuurlijke reizen. 4thscenery nam een groot deel van de social media en marketing uit handen en denkt strategisch mee over de groei van het merk.",
      servicesUsed: ["Social media", "Marketing", "Content", "Strategie"],
      workTitle: "Wat we deden",
      workItems: [
        { title: "Social media uit handen genomen", text: "Van planning tot publicatie: wij beheren de kanalen en zorgen voor een constante stroom van content die past bij het merk." },
        { title: "Strategisch meedenken", text: "We bepalen samen welke verhalen en campagnes de community verder laten groeien." },
        { title: "Ideeën omgezet in actie", text: "Van video-content tot campagnes: concepten worden snel concreet gemaakt en uitgerold." },
        { title: "Focus op de kern", text: "Het team van Mountain Men kan zich volledig richten op hun eigen werkzaamheden en de doorontwikkeling van het merk." },
      ],
      resultsTitle: "Het resultaat",
      results: [
        { title: "Sterke groei in zichtbaarheid", text: "Het merk wordt door steeds meer mensen gezien, gevolgd en herkend." },
        { title: "Nieuwe doelgroepen bereikt", text: "Content die aanslaat bij mensen die Mountain Men nog niet kenden." },
        { title: "Meer groei vanuit social", text: "Social media en marketing dragen nu structureel bij aan de groei van de community." },
        { title: "Versterkte online aanwezigheid", text: "Een actieve en herkenbare uitstraling op elk kanaal." },
      ],
      ctaTitle: "Ook jouw merk laten groeien?",
      ctaText: "Plan een gratis kennismaking van 15 minuten. We bespreken direct wat wij voor jouw social media en marketing kunnen betekenen.",
      meta: {
        title: "Project Mountain Men · 4thscenery",
        description: "Hoe 4thscenery de social media en marketing van Mountain Men overnam, met sterke groei in zichtbaarheid en bereik. Bekijk het project.",
      },
    },
    en: {
      sector: "Outdoor travel community",
      tagline: "From social media to full marketing: we took it over so Mountain Men could fully focus on building their community.",
      intro: "Mountain Men is a fast-growing community around adventurous travel. 4thscenery took a large part of the social media and marketing off their hands and thinks along strategically about growing the brand.",
      servicesUsed: ["Social media", "Marketing", "Content", "Strategy"],
      workTitle: "What we did",
      workItems: [
        { title: "Social media taken over", text: "From planning to publishing: we run the channels and keep a constant flow of on-brand content going." },
        { title: "Strategic sparring", text: "Together we decide which stories and campaigns will grow the community further." },
        { title: "Ideas turned into action", text: "From video content to campaigns: concepts are made concrete and rolled out fast." },
        { title: "Focus on the core", text: "The Mountain Men team can fully focus on their own work and the further development of the brand." },
      ],
      resultsTitle: "The result",
      results: [
        { title: "Strong growth in visibility", text: "The brand is seen, followed and recognised by more and more people." },
        { title: "New audiences reached", text: "Content that lands with people who did not know Mountain Men yet." },
        { title: "More growth from social", text: "Social media and marketing now structurally contribute to the growth of the community." },
        { title: "Strengthened online presence", text: "An active and recognisable presence on every channel." },
      ],
      ctaTitle: "Want your brand to grow too?",
      ctaText: "Book a free 15-minute intro call. We will discuss right away what we can do for your social media and marketing.",
      meta: {
        title: "Project Mountain Men · 4thscenery",
        description: "How 4thscenery took over the social media and marketing of Mountain Men, with strong growth in visibility and reach. View the project.",
      },
    },
  },
  "verjong-vastgoed": {
    client: "Verjong Vastgoed",
    url: "https://verjongvastgoed.nl/",
    logo: { src: "/media/vv-logo.png", alt: "Verjong Vastgoed logo", framed: false },
    heroPhoto: { src: "/media/vv-1.jpg", alt: "Het team van Verjong Vastgoed" },
    cardPhoto: { src: "/media/vv-1.jpg", alt: "Het team van Verjong Vastgoed", position: "center 30%" },
    photos: [
      { src: "/media/vv-1.jpg", alt: "Het team van Verjong Vastgoed" },
      { src: "/media/vv-2.jpg", alt: "Verjong Vastgoed · trots op het werk" },
      { src: "/media/vv-3.jpg", alt: "De bus van Verjong Vastgoed" },
      { src: "/media/vv-4.jpg", alt: "Verjong Vastgoed aan het werk" },
      { src: "/media/vv-5.jpg", alt: "Verjong Vastgoed · vakmanschap" },
    ],
    video: null,
    bg: VV_BG,
    quote: VV_QUOTE,
    nl: {
      sector: "Vastgoedonderhoud",
      tagline: "Een online uitstraling die past bij wat Verjong Vastgoed belooft: vertrouwen, duidelijkheid en kwaliteit.",
      intro: "Verjong Vastgoed verjongt en onderhoudt woningen en vastgoed. 4thscenery vertaalt hun dienstverlening naar een professionele en consistente online presentatie.",
      servicesUsed: ["Online presentatie", "Content", "Marketing", "Merkuitstraling"],
      workTitle: "Wat we deden",
      workItems: [
        { title: "Merk vertaald naar online", text: "De kernwaarden vertrouwen, duidelijkheid en kwaliteit vertaald naar alle online uitingen." },
        { title: "Professionele presentatie", text: "Consistente beeldtaal en teksten die passen bij de kwaliteit van het werk." },
        { title: "Content met gevoel voor het vak", text: "Foto's en verhalen van echt werk, zodat klanten zien wie ze inhuren." },
        { title: "Doorlopende partner", text: "Wij houden de online kant draaiende, zij richten zich op vastgoed en hun klanten." },
      ],
      resultsTitle: "Het resultaat",
      results: [
        { title: "Professionelere uitstraling", text: "Elke online uiting voelt nu consistent en verzorgd." },
        { title: "Verhaal goed verteld", text: "Wat Verjong Vastgoed doet en waarom, komt online helder over." },
        { title: "Vertrouwen bij nieuwe klanten", text: "Een presentatie die past bij de kwaliteit van het werk dat ze leveren." },
        { title: "Focus op het vak", text: "Zij doen het werk, wij vertellen het verhaal." },
      ],
      ctaTitle: "Ook een online uitstraling die klopt?",
      ctaText: "Plan een gratis kennismaking van 15 minuten. We kijken samen hoe jouw verhaal online sterker wordt verteld.",
      meta: {
        title: "Project Verjong Vastgoed · 4thscenery",
        description: "Hoe 4thscenery Verjong Vastgoed helpt aan een professionele en consistente online uitstraling. Bekijk het project.",
      },
    },
    en: {
      sector: "Property maintenance",
      tagline: "An online presence that matches what Verjong Vastgoed promises: trust, clarity and quality.",
      intro: "Verjong Vastgoed rejuvenates and maintains homes and real estate. 4thscenery translates their service into a professional and consistent online presentation.",
      servicesUsed: ["Online presence", "Content", "Marketing", "Brand identity"],
      workTitle: "What we did",
      workItems: [
        { title: "Brand translated online", text: "The core values trust, clarity and quality translated into every online expression." },
        { title: "Professional presentation", text: "Consistent imagery and copy that match the quality of the work." },
        { title: "Content with a feel for the craft", text: "Photos and stories of real work, so customers see who they are hiring." },
        { title: "Ongoing partner", text: "We keep the online side running, they focus on property and their customers." },
      ],
      resultsTitle: "The result",
      results: [
        { title: "More professional presence", text: "Every online expression now feels consistent and polished." },
        { title: "Story told right", text: "What Verjong Vastgoed does and why comes across clearly online." },
        { title: "Trust with new customers", text: "A presentation that matches the quality of the work they deliver." },
        { title: "Focus on the craft", text: "They do the work, we tell the story." },
      ],
      ctaTitle: "Want an online presence that fits too?",
      ctaText: "Book a free 15-minute intro call. Together we will look at how your story can be told stronger online.",
      meta: {
        title: "Project Verjong Vastgoed · 4thscenery",
        description: "How 4thscenery helps Verjong Vastgoed with a professional and consistent online presence. View the project.",
      },
    },
  },
};

export const CASES_OVERVIEW = {
  nl: {
    eyebrow: "Projecten",
    title: "Resultaten waar we trots op zijn",
    intro: "We laten ons werk liever zien dan erover te praten. Bekijk hoe we samenwerken met Mountain Men en Verjong Vastgoed.",
    cardCta: "Bekijk dit project",
    extraTitle: "Benieuwd wat wij voor jou kunnen betekenen?",
    extraText: "Plan een gratis kennismaking van 15 minuten. We kijken direct met je mee welke stappen jouw bedrijf verder helpen.",
    extraCta: "Plan een gratis kennismaking",
    meta: {
      title: "Projecten · 4thscenery",
      description: "Bekijk de projecten van 4thscenery: Mountain Men en Verjong Vastgoed. Marketing die zichtbaar resultaat oplevert.",
    },
  },
  en: {
    eyebrow: "Projects",
    title: "Results we are proud of",
    intro: "We prefer to show our work rather than talk about it. See how we work with Mountain Men and Verjong Vastgoed.",
    cardCta: "View this project",
    extraTitle: "Curious what we can do for you?",
    extraText: "Book a free 15-minute intro call. We will look right away at which steps move your business forward.",
    extraCta: "Book a free intro call",
    meta: {
      title: "Projects · 4thscenery",
      description: "Explore the 4thscenery projects: Mountain Men and Verjong Vastgoed. Marketing that delivers visible results.",
    },
  },
};
